import React, { ReactNode, useState } from "react";
import { Button } from "@jsq/ds/core";
import { CollapsibleContent_Button, CollapsibleContent_Children } from "./styles_vanilla.css";

export type ChildrenCallbackObject = {
  isExpanded: boolean;
  button: JSX.Element;
};

type Props = {
  isInitiallyExpanded?: boolean;
  children?: (obj: ChildrenCallbackObject) => ReactNode;
  showMoreText?: string;
  showLessText?: string;
  onToggle?: (isExpanded: boolean) => void;
};

const CollapsibleContent: React.FunctionComponent<Props> = ({
  children,
  isInitiallyExpanded = false,
  showMoreText = "view more",
  showLessText = "view less",
  onToggle = () => {},
}) => {
  const [isExpanded, setIsExpanded] = useState(isInitiallyExpanded);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
    onToggle?.(!isExpanded);
  };

  const button = (
    <Button variant="link" className={CollapsibleContent_Button} onClick={handleToggle}>
      {isExpanded ? showLessText : showMoreText}
    </Button>
  );

  return (
    <div
      data-cy="collapsible-context-container"
      data-testid="collapsible-context-container"
      className={CollapsibleContent_Children}
    >
      {children?.({ isExpanded: !!isExpanded, button })}
    </div>
  );
};

export default CollapsibleContent;
